<div class="flex flex-wrap items-center justify-start gap-2">
  @if (showSearch) {
  <div class="relative sm:ltr:mr-auto sm:rtl:ml-auto">
    <form
      class="absolute inset-x-0 top-1/2 z-10 mx-4 hidden -translate-y-1/2 sm:relative sm:top-0 sm:mx-0 sm:block sm:translate-y-0"
      [ngClass]="{ '!block': searchExpanded }"
      (ngSubmit)="submitSearchMobile($event)"
    >
      <div class="relative">
        <input
          type="text"
          name="listModuleSearch"
          [(ngModel)]="filters.searchQuery"
          (ngModelChange)="onSearchInput()"
          class="peer form-input bg-white py-3 px-4 placeholder:tracking-widest ltr:pl-9 ltr:pr-9 rtl:pl-9 rtl:pr-9 sm:bg-white ltr:sm:pr-4 rtl:sm:pl-4 rounded-full dark:bg-[#0e1726] dark:border-[#191e3a]"
          [placeholder]="searchPlaceholder"
        />
        <button
          type="button"
          class="absolute inset-0 top-1/2 -translate-y-1/2 left-1 h-9 w-9 appearance-none peer-focus:text-primary ltr:right-auto rtl:left-auto"
          tabindex="-1"
          aria-hidden="true"
        >
          <icon-search class="mx-auto" />
        </button>
        <button
          type="button"
          class="absolute top-1/2 block -translate-y-1/2 hover:opacity-80 ltr:right-2 rtl:left-2 sm:hidden"
          (click)="searchExpanded = false"
          aria-label="Close search"
        >
          <icon-x-circle />
        </button>
      </div>
    </form>
    <button
      type="button"
      class="search_btn rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
      (click)="searchExpanded = !searchExpanded"
      aria-label="Open search"
    >
      <icon-search class="mx-auto h-4.5 w-4.5 dark:text-[#d0d2d6]" />
    </button>
  </div>
  }

  @if (showStatus) {
  <div class="relative">
    <select
      id="listModuleStatusFilter"
      name="listModuleStatus"
      class="form-select bg-white py-3 px-4 dark:bg-dark text-white-dark rounded-full border-white-light dark:border-[#191e3a]"
      [(ngModel)]="filters.status"
      (ngModelChange)="onStatusChange()"
    >
      @for (opt of statusOptions; track opt.value) {
      <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  </div>
  }

  @if (showDateRange) {
  <div class="relative min-w-[260px] max-w-full">
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center ps-3">
      <icon-calendar class="size-5 text-gray-500 dark:text-gray-400" />
    </div>
    <input
      #dateRangePicker="mwlFlatpickr"
      type="text"
      name="listModuleDateRange"
      mwlFlatpickr
      [(ngModel)]="filters.dateRange"
      [mode]="'range'"
      [dateFormat]="'Y-m-d'"
      [convertModelValue]="false"
      [disableMobile]="true"
      [placeholder]="dateRangePlaceholder"
      (flatpickrChange)="onDateRangeChange($event)"
      class="peer form-input w-full py-3 px-4 bg-white rounded-full sm:bg-white dark:bg-[#0e1726] dark:border-[#191e3a]"
      [ngClass]="
        hasActiveDateFilter
          ? 'ltr:pl-9 ltr:pr-14 rtl:pl-14 rtl:pr-9'
          : 'ltr:pl-9 ltr:pr-9 rtl:pl-9 rtl:pr-9'
      "
    />
    @if (hasActiveDateFilter) {
    <button
      type="button"
      class="absolute inset-y-0 right-2 z-10 flex items-center rounded-full p-1 text-gray-500 hover:bg-black/[0.06] hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-gray-200"
      title="Clear date filter"
      aria-label="Clear date filter"
      (click)="clearDateRangeFilter($event)"
    >
      <icon-x-circle class="size-5" />
    </button>
    }
  </div>
  }

  <ng-content select="[toolbarFiltersExtra]" />
</div>
